import { useMemo } from 'react';

import { ChangedNodes, TreeNode } from '../types';

import { traverseTreeChildren } from './traverseTreeChildren';

/**
 * Создает пары TreeNode - checked из пары id - checked
 * @param changedNodes измененные пользователем чекбоксы
 * @param nodes деревья
 * @param initialCheckboxValue значение чекбоксов по умолчанию
 */
export function useMappedCheckboxState(
    changedNodes: ChangedNodes,
    nodes: TreeNode[],
    initialCheckboxValue: boolean,
): ReadonlyMap<TreeNode, boolean> {
    return useMemo(() => {
        const serialized = new Map(changedNodes);
        const result = new Map<TreeNode, boolean>();

        traverseTreeChildren<boolean>(nodes, (node, parentValue = initialCheckboxValue) => {
            const value = serialized.get(node.id);
            if (value !== undefined && parentValue !== value) {
                result.set(node, value);
            }

            return value ?? parentValue;
        });

        return result;
    }, [changedNodes, initialCheckboxValue, nodes]);
}
